// extracted by mini-css-extract-plugin
export var footer = "_r2-0";
export var inherit = "_r2-1";
export var input = "_r2-2";
export var modalContent = "_r2-3";
export var quillEditor = "_r2-4";
export var subtitle = "_r2-5";